export enum SpaceframeAppearance {
  Antares,
  ClassJCargoShip,
  Eleos,
  Freighter,
  JovisType,
  Merchantman,
  XhosaType,
  KaplanF17PatrolFrigate,
  ConestogaType,

  // Romulan
  Aelahl,
  BirdOfPrey22ndCentury,
  Tliss,
  RomulanD7,
  Whitewind,
  DDeridex,
  RomulanScienceVessel,
  Mogai,
  RedLadyType,
  Snakehead,
  ScimitarType,
  Khnial,

  // Orion
  DVar,
  Intruder,
  Interceptor,
  Orchid,

  // Discovery-era Federation ships
  Kirk,
  Janeway,
  Friendship,
  Eisenberg,

  // Shuttles
  Type6Shuttle,
  Type8Shuttle,
  Type9Shuttle,
  Type10Shuttle,
  Type16Shuttle,
  ArgoClassShuttle,

  RomulanShuttle,
  RemanScorpionFighter,
}
